import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { QueryParamsModel } from 'src/app/core/_base/crud';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/reducers';
import { MessageViewComponent } from 'src/app/views/pages/apps/timeline/messages/message-view/message-view.component';
import { Message } from 'src/app/core/timeline/_models/message.model';
import { MessageStatusUpdated } from 'src/app/core/timeline/_actions/message.actions';
import { MessageService } from 'src/app/core/timeline/_services/message.service';

@Component({
  selector: 'kt-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['notification.component.scss'],
})
export class NotificationComponent implements OnInit, OnDestroy {
  @Input() icon = 'flaticon2-bell-alarm-symbol';
  @Input() useSVG: boolean;
  notifications: any[] = [];
  unreadCount = '0';
  hidden = true;
  indexOfList = 0;
  noMore = false;
  constructor(
    public dialog: MatDialog,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService,
  ) {
    this.getCountOfUnreadMessages();
  }

  ngOnInit() {
    this.messageService.$loadCount.subscribe((res) => {
      if (res) {
        this.getCountOfUnreadMessages();
      }
    });
  }

  ngOnDestroy() {
    this.notifications = [];
  }

  loadMessagesList() {
    this.indexOfList = 0;
    this.noMore = false;
    const pageNumber = this.indexOfList;
    const queryParams = new QueryParamsModel('', 'asc', '', pageNumber, 10);
    this.messageService.findMessages(queryParams).subscribe((res) => {
      this.notifications = res.data;
      this.hidden = true;
      this.cdr.detectChanges();
    });
  }

  onScroll(event) {
    if (this.noMore) return;
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - 5) {
      setTimeout(() => this.loadMoreMessages(), 250);
    }
  }

  loadMoreMessages() {
    const pageNumber = ++this.indexOfList;
    const queryParams = new QueryParamsModel('', 'asc', '', pageNumber, 10);
    this.messageService.findMessages(queryParams).subscribe((res) => {
      if (res?.data.length > 0) {
        this.notifications = this.notifications.concat(res.data);
        this.cdr.detectChanges();
        return;
      }
      this.noMore = true;
      this.cdr.detectChanges();
    });
  }

  getCountOfUnreadMessages() {
    this.messageService.loadUnreadMessageCount().subscribe((count) => {
      this.messageService.setUnreadMessageCount(count?.data?.count || '0');
      this.unreadCount = this.messageService.getUnreadMessageCount().toString();
      this.cdr.detectChanges();
    });
  }

  viewMessage(message: Message) {
    const dialogRef = this.dialog.open(MessageViewComponent, { width: '60vw', data: { message } });
    dialogRef.afterClosed().subscribe(() => {
      if (message.is_completed !== true) {
        this.messageService.unreadMessages(message.id).subscribe(() => {
          const notification = this.notifications.find((note) => note.id === message.id);
          this.store.dispatch(
            new MessageStatusUpdated({ id: notification.id, is_completed: true }),
          );
          this.notifications.splice(notification.id, 1, notification);
          this.getCountOfUnreadMessages();
          this.cdr.detectChanges();
        });
      }
    });
  }

  getItem(type: boolean): string {
    return !type ? './assets/media/svg/icons/Design/Circle.svg' : '';
  }

  getDate(created: any) {
    return new Date(created + ' GMT').toLocaleString();
  }
}
